<div class="modal-header">
  <!--ep-task-action-modal-->
  <h4 class="modal-title">File Documents</h4>
  <button unity-button
    class="close"
    classes="icon-only icon-only-large on_dark"
    type="button"
    (click)="activeModal.dismiss('Cross click')"
  >
    <svg class="unity-icon unity-icon-times">
      <use xlink:href="#unity-icon-times"></use>
    </svg>
  </button>
</div>
<div class="modal-body">
  <dataservice-error></dataservice-error>
  <div *ngIf="documents" style="margin: 0px">
    <ep-multi-document-file-edit-panel [documents]="documents"></ep-multi-document-file-edit-panel>
  </div>

  <div *ngFor="let filing of filings$ | async; let row = index">
    <ep-multi-document-filing-edit-panel
      *ngIf="filing.DocLink_ID <= 0"
      [item]="filing"
      [firstRow]="row === 0"
    ></ep-multi-document-filing-edit-panel>
  </div>
</div>
<div class="modal-footer">
  <!--ep-task-action-modal-->
  <button unity-button classes="primary" type="button" (click)="save()" [disabled]="model.inProgress">
    <div *ngIf="!model.inProgress && !model.filingComplete">
      <span>Save</span>
    </div>
    <div *ngIf="model.inProgress && !model.filingComplete">
      <span>{{ documents.length - model.fileNumber }}</span>
    </div>
    <div *ngIf="!model.inProgress && model.filingComplete">
      <span>Done</span>
    </div>
  </button>
  <!-- <button
    type="button"
    class="btn btn-primary"
    [disabled]="model.taskLinkType == 'NOTASK'"
    (click)="saveAndStartTask()"
  >
    <i
      style="margin-right: 4px"
      [class]="
        'fa fa-fw ' +
        (model.autoOpenTask && (app.dsTaskProcess.status == 'Loading' || app.dsTaskGet.status == 'Loading')
          ? 'fa-ep-loading'
          : 'fa-ep-task-start')
      "
      [class.fa-spin]="
        model.autoOpenTask && (app.dsTaskProcess.status == 'Loading' || app.dsTaskGet.status == 'Loading')
      "
    ></i
    ><span>Save &amp; Start Task</span>
  </button> -->
  <!-- <button type="button" class="btn btn-primary" (click)="saveAndRoute()">Save &amp; Route</button> -->
  <!-- <button type="button" class="btn btn-primary" (click)="saveAndDistribute()">Save &amp; Distribute</button> -->
  <button unity-button classes="ghost" type="button" (click)="cancel()">Cancel</button>
</div>
